export default "__VITE_ASSET__BX9muGlt__"